<template>
  <div>
    <Tool>
      <template v-slot:title>
        <h1 class="tool-title-h1">
          用户管理
        </h1>
      </template>
      <template v-slot:content>
        <a-icon type="search" style="color: white; font-size: 20px"/>
        <a-input placeholder="查询姓名..." v-model="queryParam.searchValue" @change="search"
                 style="width: 250px; background-color: transparent; color: white; border: none">
        </a-input>
      </template>
    </Tool>
    <div class="content">
      <div style="margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between">
        <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">预约</a-button>
      </div>
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          :scroll="{x: 1500}"
          bordered
          @change="handleTableChange">
        <template slot="status" slot-scope="status">
          <template v-if="status === '提交'">
            <a-icon type="info-circle" theme="twoTone" style="font-size: 18px" :title=status two-tone-color="orange"/>
          </template>
          <template v-if="status === '预约'">
            <a-icon type="clock-circle" theme="twoTone" :title=status style="font-size: 18px"/>
          </template>
          <template v-if="status === '成功'">
            <a-icon type="check-circle" theme="twoTone" style="font-size: 18px" :title=status
                    two-tone-color="#52c41a"/>
          </template>
          <template v-if="status === '停止'">
            <a-icon type="stop" theme="twoTone" style="font-size: 18px" :title=status two-tone-color="red"/>
          </template>
        </template>
        <template slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.status === '停止' || (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleStop(record)">停止</a>
              </a-menu-item>
              <a-menu-item v-if="record.status !== '完成' && (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleFinish(record)">完成</a>
              </a-menu-item>
              <a-menu-item v-if="username.indexOf('super') !== -1 || username.indexOf('admin') !== -1">
                <a @click="handleInit(record)">初始化</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
    <create-modal ref="createModal" @ok="loadData"></create-modal>
  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'
import {TableMixins} from '@/mixins/table-mixins'
import debounce from "lodash/debounce";
import CreateModal from "@/components/mxApplicant/CreateModal";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: 'MxApplicant',
  components: {
    Tool,
    CreateModal
  },
  mixins: [HttpMixins, TableMixins],
  data() {
    return {
      queryParam: {
        searchValue: ''
      },
      username: localStorage.getItem('username'),
      columns: [
        {
          title: '状态',
          align: "center",
          dataIndex: 'status',
          filters: [
            {text: '提交', value: '提交'},
            {text: '预约', value: '预约'},
            {text: '成功', value: '成功'},
            {text: '停止', value: '停止'},
          ],
          width: 100,
          fixed: 'left',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: 'UID',
          align: "center",
          dataIndex: 'uid',
          fixed: 'left',
          width: 150
        },
        {
          title: '姓名',
          align: "center",
          dataIndex: 'name',
          fixed: 'left',
          width: 120
        },
        {
          title: '英文名称',
          align: "center",
          dataIndex: 'englishName',
          fixed: 'left',
          width: 200
        },

        {
          title: '签证类型',
          align: "center",
          dataIndex: 'type',
          width: 150
        },
        {
          title: '领区',
          align: "center",
          dataIndex: 'area',
          width: 150,
          filters: [
            {text: 'BEIJING', value: 'BEIJING'},
            {text: 'SHANGHAI', value: 'SHANGHAI'},
            {text: 'GUANGZHOU', value: 'GUANGZHOU'},
          ],
        },
        {
          title: '性别',
          align: "center",
          dataIndex: 'sex',
          width: 100
        },
        {
          title: '婚否',
          align: "center",
          dataIndex: 'married',
          width: 100
        },
        {
          title: '出生日期',
          align: "center",
          dataIndex: 'birthday',
          width: 120
        },
        {
          title: '电话',
          align: "center",
          dataIndex: 'phone',
          width: 120
        },
        {
          title: '护照',
          align: "center",
          dataIndex: 'passport',
          width: 200
        },
        {
          title: '批文',
          align: "center",
          dataIndex: 'unt',
          width: 120
        },
        {
          title: '预约开始日期',
          align: "center",
          dataIndex: 'applicantStart',
          width: 120
        },
        {
          title: '预约最后日期',
          align: "center",
          dataIndex: 'applicantEnd',
          width: 120
        },
        {
          title: '预约时间',
          align: "center",
          dataIndex: 'applicantTime',
          width: 200
        },
        {
          title: '修改时间',
          align: "center",
          dataIndex: 'updateTime',
          width: 200
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime',
          width: 200
        },
        {
          title: '备注',
          align: "center",
          dataIndex: 'remark',
          width: 200
        },
        {
          title: '所有者',
          align: "center",
          dataIndex: 'user',
          width: 150
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ],
      url: {
        list: window._CONFIG['domainURL'] + "/mxApplicant/list",
        update: window._CONFIG['domainURL'] + "/mxApplicant",
        finish: window._CONFIG['domainURL'] + "/mxApplicant/finish",
        stop: window._CONFIG['domainURL'] + "/mxApplicant/stop",
        init: window._CONFIG['domainURL'] + "/mxApplicant/init",
      }
    }
  },
  methods: {
    handleAdd: function () {
      this.$refs.createModal.show();
    },
    handleEdit(record) {
      this.$refs.createModal.show(record);
    },
    search: debounce(function () {
      this.pagination.current = 1;
      this.loadData();
    }, 800),
    handleFinish: function (record) {
      let that = this;
      that.loading = true;
      let param = {
        id: record.id
      }
      that.$axios.put(that.url.finish, param, {headers: that.headers}).then((res) => {
        let response = res.data;
        if (response.code === 200) {
          that.$message.success(response.msg);
          that.loadData();
        } else {
          that.$message.error(response.msg);
        }
      }).catch((error) => {
        that.catchError(error)
      }).finally(() => {
        that.loading = false;
      });
    },

    handleStop: function (record) {
      let that = this;
      that.loading = true;
      let param = {
        id: record.id
      }
      that.$axios.put(that.url.stop, param, {headers: that.headers}).then((res) => {
        let response = res.data;
        if (response.code === 200) {
          that.$message.success(response.msg);
          that.loadData();
        } else {
          that.$message.error(response.msg);
        }
      }).catch((error) => {
        that.catchError(error)
      }).finally(() => {
        that.loading = false;
      });
    },

    handleInit: function (record) {
      let that = this;
      that.loading = true;
      let param = {
        id: record.id
      }
      that.$axios.put(that.url.init, param, {headers: that.headers}).then((res) => {
        let response = res.data;
        if (response.code === 200) {
          that.$message.success(response.msg);
          that.loadData();
        } else {
          that.$message.error(response.msg);
        }
      }).catch((error) => {
        that.catchError(error)
      }).finally(() => {
        that.loading = false;
      });
    },
  },
  created() {
    this.loadData();
  }
}
</script>
